
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: prod.Kindera.ts;
 * Path: ./src/environments/prod.Kindera.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 14/05/25, 10:10;
 * Updated at: 14/05/25, 10:10;
 *
 */

import { environment as Env } from './BaseEnvironments/Kindera';
import { getModule } from './Utility/ModuleUtility';

var Environment = () => {
  var env = Env;
  env.apiUrl = 'https://www.kindera.cloud/api';
  env.logoPath = 'assets/images/logo-kindera.png';
  env['TelegramBotToken']="6990226380:AAHWBH4C1dDsnGvDFU0XB6H5dnRJiYK36Hw";
  env['TelegramChatId']=-4248506776;
  env['TelegramBotPlatformName'] = "Kindera Prod";
  env['chatApiUrl'] = 'https://www.kindera.cloud/chatapi';
  env['encryptionKey'] = "z)_2VZ%5NL)st~_f";
  env['oneSignalAppId'] = '16bb6c1e-2117-426e-8f41-39458aba80c3'
  return env;
};

export var environment = getModule(Environment());
